var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"artigos-hero px-8 py-10"},[_c('div',{staticClass:"artigos-hero__content"},[_c('h1',{staticClass:"hero-title mb-2"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"artigos-hero__subtitle ma-0"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }